export default "__VITE_ASSET__f2c9d75e__"